<style scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9;
  background: #000;
  opacity: .3;
}

.modal-alert {
  position: fixed;
  width: 1200px;
  background: #fff;
  z-index: 9;
  left: 50%;
  top: 50%;
  margin-left: -480px;
  transform: translateY(-50%);
  padding-bottom: 20px;
}

.title-close {
  height: 50px;
  border-bottom: 1px solid #D9D9D9;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  font-size: 18px;
  color: #212121;
}
.title-close div{
  height: 100%;
  line-height: 50px;
}

.modal-alert .btns {
  width: 60px;
  height: 28px;
  background: #4FA1A4;
  border-radius: 2px;
  color: #fff;
  margin-top: 15px;
  float: right;
  margin-right: 20px;
  line-height: 28px;
  cursor: pointer;
}

.modal-alert .close {
  cursor: pointer;
  color: #909399;
}

.modal-alert .close:hover {
  color: #409EFF;
}

.modal-alert .tips {
  background: #FFFBF2;
  border: 1px solid rgba(255, 241, 212, 1);
  border-radius: 4px;
  margin: 15px;
  text-align: left;
  padding: 10px 20px;
  line-height: 25px;

}

.modal-alert .sub-title {
  font-size: 16px;
  color: #212121;
  text-align: left;
  margin-left: 20px;
  display: flex;
  align-items: center;
}

.modal-alert .sub-title span {
  background: #4FA1A4;
  width: 4px;
  height: 16px;
  display: inline-block;
  margin-right: 8px;
}

.person-search {
  display: flex;
  padding-left: 30px;
  padding-top: 10px;
  align-items: center;
  color: #666;
}

.person-search .item1 {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.person-search .item1 .label {
  margin-right: 10px;
}

.person-search .select-wrap {
  width: 250px;
}

/deep/ .table_header {
  background-color: #F0F0F0 !important;
  padding: 10px 0;
  color: #323233;
  overflow-x: scroll;
}

/deep/ .el-table td {
  padding: 10px 0px;
}
/deep/.el-input-number__decrease{
  height: 33px; 
  top:3px
}
/deep/ .el-input-number__increase{
  height: 33px; 
  top:3px
}

.table-wrap {
  margin: 20px
}
.btns.cancel {
  background: #FFFFFF;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color:#666;
}
</style>
<template>
  <div class="main" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="modal" @click="close"></div>
    <div class="modal-alert" :style="detail.taskPriceModel == 1?'width:700px; margin-left: -350px;':''">
      <div class="title-close">
        <div class="title" style="margin-bottom:0">修改人员任务</div>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <div class="tips">
        1、如果调整人员或者任务太多，请至【批量调整任务量】功能修改；<br>
        2、如需删除任务，请至【删除人员任务】 功能处理；<br>
        3、如果任务量修改为0，那么移动端任务将不展示，人员将无法继续执行任务，请慎重修改!
      </div>

      <div class="sub-title"><span></span>业务员执行情况</div>
      <div class="person-search">
        <div class="item1">
          <div class="label">选择人员</div>
          <el-select class="select-wrap" v-model="staffGuid" placeholder="请选择人员" filterable @change="staffChange">
            <el-option v-for="item in staffList" :key="item.staffGuid" :label="item.staffName+'-'+item.mobileNo" :value="item.staffGuid"></el-option>
          </el-select>
        </div>
        <div class="item2">
          所在部门：{{ organisationNames||'-' }}
        </div>
      </div>
      <div class="table-wrap" v-show="detailData&&detailData.length>0">

        <el-table ref="mListTable"  @selection-change="handleSelectionChange"  :data="detailData" max-height="400px"   stripe border header-cell-class-name="table_header">
          <el-table-column fixed="left" type="selection"  width="40" header-align="center"
            align="center"></el-table-column>
          <el-table-column label="序号" width="50" header-align="center" align="center">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column label="项目任务名称" show-overflow-tooltip  width="110" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.taskContentName || '-' }}</template>
          </el-table-column>
          <el-table-column label="业务员价格" width="100" 
            header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.taskPrice||'-' }} </template>
          </el-table-column>

          <el-table-column v-if="detail.taskPriceModel == 2" label="药企任务价格" width="108" 
            header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.tenantPrice||'-' }} </template>
          </el-table-column>
          <el-table-column v-if="detail.taskPriceModel == 2" label="业务员基础报价" width="120" 
            header-align="center" align="right">
            <template slot-scope="scope">{{ scope.row.staffBasePrice||'-' }} </template>
          </el-table-column>
          
          <el-table-column v-if="detail.taskPriceModel == 2" label="业务员能力系数" width="120" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.staffCoefficient||'-'}}</template>
          </el-table-column>
          <el-table-column v-if="detail.taskPriceModel == 2" label="调研内容深度系数" width="134" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.ruleCoefficient||'-'}}</template>
          </el-table-column>
          <el-table-column v-if="detail.taskPriceModel == 2" label="浮动比例" width="80" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.floatDiscountRatio||'-'}}</template>
          </el-table-column>
          <el-table-column v-if="detail.taskPriceModel == 2" label="折扣比例" width="80" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.discountRatio||'-'}}</template>
          </el-table-column>
          <el-table-column label="已完成量" width="80" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.realCount}}</template>
          </el-table-column>

          <el-table-column label="任务量" header-align="center" align="center">
            <template slot-scope="scope" >
              <div v-if="!scope.row.isNotLimit">
                <el-input-number  style="width:130px;" :min="0" v-model="scope.row.planCount"></el-input-number>
                <div style="color:red;" v-if="scope.row.planCount<scope.row.realCount">任务量不能低于已完成量</div>
              </div>
              <div v-else>
                不限量
              </div>
            </template>
          
          </el-table-column>
        </el-table>
      </div>
      <div class="btns " @click="submit">
        确定
      </div>
      <div class="btns cancel" @click="close">
        取消
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      selectable:[],
      staffGuid: '',
      staffList: [{ label: 'yanyi', value: '1' }],
      organisationNames:'',
      detailData: [],
      fullscreenLoading:false,
      selectTable:[]
    };
  },
  created() {
    this.getStaffList();
  },
  methods: {
    close() {
      this.$emit('close')
    },
    //查询人
    getStaffList() {
      let query = {
        taskMainGuid: this.detail.guid,
      };
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-staff-pack-task-info`, query).then((res) => {
        this.fullscreenLoading = true;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList = res.data.data;
          this.fullscreenLoading = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    staffChange(val) {
      this.staffList.forEach(item => {
        if (item.staffGuid == val) {
          console.log(item)
          this.organisationNames =  item.organisationNames?item.organisationNames.join('、'):'';
        }
      })
      this.getDetailList()
    },
    //查询明细
    getDetailList() {
      let query = {
        pageIndex: 0,
        pageSize: 100,
        taskMainGuid: this.detail.guid,
        staffGuid: this.staffGuid,
        isAppendBlank:'Y',
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/staff/get`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.detailData = res.data.data.pageData.records;
          // 纯标注任务包选了不满足标注人员要求的人员时，后端过滤后明细为空——即时提示而非表格静默隐藏
          if (this.detailData.length == 0) {
            this.$message.warning('该人员无可修改的任务明细（数据标注任务行仅对满足标注人员要求的人员展示）');
          }
          this.$nextTick(() => {
            for (let i = 0; i < this.detailData.length; i++) {
              this.$refs.mListTable.toggleRowSelection(this.detailData[i], true)
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    handleSelectionChange(val){
      this.selectTable = val;
    },
    //提交
    submit(){
      let req = [];
 
      if (!this.staffGuid) {
        this.$message.error('请先选择人员');
        return
      }
      if (this.detailData.length == 0) {
        this.$message.error('明细为空，请重新选择人员');
        return
      }
      if(this.selectTable.length == 0){
        this.$message.error('请至少勾选一个任务');
        return
      }
      this.$forceUpdate();
      try {
        this.selectTable.forEach(item => {
          //isNotLimit 1 不限量 0限量
          if ((item.planCount < item.realCount) && item.isNotLimit == 0) {
            throw new Error(`${item.taskContentName}任务量不能小于已完成量`);
          }
          req.push({
            taskMainGuid: item.taskMainGuid,
            taskDetailGuid: item.taskDetailGuid,
            taskDetailStaffGuid: item.guid,
            staffGuid: this.staffGuid,
            planCount: item.planCount
          });
        })
      } catch (e) {
        this.$message.error(e.message);
        return;
      }
      let url = this.isShenHe()? `/${serverConfig.msSalesPerformService}/task-flow-approve/edit-plan-batch-todo`:`/${serverConfig.msSalesPerformService}/task-flow-approve/edit-plan-batch`
      this.fullscreenLoading = true;
      this.api.postJson(url, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('提交成功');
          //清空表单
          this.staffGuid = '';
          this.organisationNames = '';
          this.detailData = [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    isShenHe(){
      let state = this.detail.state;
      let bizApproveVO = this.detail.bizApproveVO;
      if (state == '待派发') {
        return false;
      }
      if ((state == '已派发'||state == '部分结算') &&bizApproveVO) {
        return true;
      }
      return false;
    }

  },
};
</script>